var map = {
	"./de/hos.yml": 154,
	"./de/main.yml": 28,
	"./de/sfs.yml": 155,
	"./en/example.yml": 156,
	"./en/hos.yml": 157,
	"./en/main.yml": 29,
	"./en/markdown.yml": 158,
	"./en/news.yml": 159,
	"./en/sfs.yml": 160,
	"./fr/example.yml": 161,
	"./fr/hos.yml": 162,
	"./fr/main.yml": 30,
	"./fr/markdown.yml": 163,
	"./fr/news.yml": 164,
	"./fr/sfs.yml": 165,
	"./hr/hos.yml": 166,
	"./hr/main.yml": 31,
	"./hr/sfs.yml": 167,
	"./it/hos.yml": 168,
	"./it/main.yml": 32,
	"./it/sfs.yml": 169,
	"./oc/hos.yml": 170,
	"./oc/main.yml": 33,
	"./oc/sfs.yml": 171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;